module.exports = __webpack_public_path__ + "img/logo.1f7bb1f9.png";